import React, { Component } from 'react';
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PootsyTitle, PootsyButton } from './DesignFunctions'
import { PootsyTextInput } from './InputsFunctions'

import * as actions from "../actions/acAuth"
import InputsChangeHandler from "./InputsChangeHandler";

class ForgotPassword extends Component {
	render() {
		let { t } = this.context
		return(
			<InputsChangeHandler onChange={this.handleFormChanges}>
			<div className="ForgotPassword">
				<PootsyTitle title={t('login_header')}/>
				<div className="forgot-password-prompt">{t('forgot_password_prompt')}</div>
				<PootsyTextInput
					placeholder={t('email_input_placeholder')}
					name="email"
					label={t('email_input_label')}
					value={this.props.data.forgotPassword}

				/>
				<div className="buttons">
					<Link key="a" to="/auth/signin" className="cancel">{t('cancel')}</Link>
					<PootsyButton text={t('send_recovery_email_button')}
								  onClick={this.onForgotPasswordButtonClick}
								  disabled={!this.props.meta.canSubmit}
					/>
				</div>
			</div>
			</InputsChangeHandler>
		)
	}

    handleFormChanges = changes => {
        this.props.dispatch(actions.processDataChange(changes))
    }

    onForgotPasswordButtonClick = () => {
        this.props.dispatch(actions.forgotPassword())
    }
}

ForgotPassword.contextTypes = { t: PropTypes.func }
const mapStateToProps = state => ({
    data: state.dataReducer.forgotPassword,
    meta: state.metadataReducer.forgotPassword
})

export default connect(mapStateToProps)(ForgotPassword);



// WEBPACK FOOTER //
// ./src/components/ForgotPassword.js